import { createFileRoute, Navigate } from '@tanstack/react-router'
import { installations, useInstallation } from '@/installation/api'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/',
)({
  params: {
    parse: (rawParams) => ({ assetId: parseInt(rawParams.assetId) }),
  },
  loader: ({ context: { queryClient }, params: { assetId } }) =>
    queryClient.ensureQueryData(installations.detail(assetId)),
  component: RouteComponent,
})

function RouteComponent() {
  const { assetId, organizationId, locationId } = Route.useParams()
  const { data: asset } = useInstallation(assetId)

  return (
    <Navigate
      to="/organization/$organizationId/locations/$locationId/equipment/$equipmentId"
      params={{
        organizationId,
        locationId,
        equipmentId: asset.equipment,
      }}
      replace
    />
  )
}
